import React from 'react';

interface SkeletonProps {
  style?: React.CSSProperties;
  className?: string;
}

export function SkeletonLoader({ style, className }: SkeletonProps) {
  return (
    <div className={`bento-skeleton ${className || ''}`} style={style}>
      <div className="skeleton-shimmer" />
    </div>
  );
}
